// This file is AUTOGENERATED, do not edit it manually!!!

export const customFields = {
    allActivities: 'Activity (task, risk, request)',
    AllActivities_group_title: 'Activity (task, risk, request) fields',
    issue: 'Risk',
    Issue_group_title: 'Risk fields',
};
